import { supabase } from '@/lib/supabase/client'

export type LeadInsert = {
  full_name: string
  email: string
  business_area?: string
  message?: string
  company?: string
  employee_count?: string
  uses_excel?: boolean
  phone_number?: string
  score?: number
  summary?: string
}

export type Lead = {
  id: string
  created_at: string
  full_name: string
  email: string
  business_area: string | null
  message: string | null
  status: string
  company: string | null
  employee_count: string | null
  uses_excel: boolean | null
  phone_number: string | null
  score: number | null
  summary: string | null
}

export const createLead = async (lead: LeadInsert) => {
  const { data, error } = await supabase
    .from('leads')
    .insert([lead])
    .select()
    .single()

  return { data, error }
}

export const getLeads = async (startDate?: Date) => {
  let query = supabase
    .from('leads')
    .select('*')
    .order('created_at', { ascending: false })

  if (startDate) {
    query = query.gte('created_at', startDate.toISOString())
  }

  const { data, error } = await query

  return { data: data as Lead[], error }
}

export const updateLeadStatus = async (id: string, status: string) => {
  const { data, error } = await supabase
    .from('leads')
    .update({ status })
    .eq('id', id)
    .select()
    .single()

  return { data, error }
}

export const deleteLead = async (id: string) => {
  const { error } = await supabase.from('leads').delete().eq('id', id)

  return { error }
}
